import * as Yup from 'yup'

const menuPublicationAgeReportSchema = Yup.object().shape({
  dateRange: Yup.array().required('Date range is required'),
  menuType: Yup.string().required('Menu type is required'),
})

export default menuPublicationAgeReportSchema
